import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-facts-box',
  templateUrl: './facts-box.component.html',
  styleUrls: ['./facts-box.component.css']
})
export class FactsBoxComponent implements OnInit {

  @Input()
  factsHeader: string;

  @Input()
  facts: string[];

  @Input()
  circleWidths: string[];

  isMobile() {
    return document.body.clientWidth < 991.98;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
